import config from '@/config'
import axios from 'axios'

const instance = () =>
  axios.create({
    baseURL: `${config.COMMU}/api/next-capital/customer`,
    timeout: 30000,
    headers: {
      AUTHORIZATION:
        'Bearer OEg4MkxMVEtrWlVpYXRkRnhsWmVteXZxeis4TU5UejBURFo0ZDlXbU1Xc2FSdDhGbU5HdWpvK2hEVThvN0VQcVVmbjV3L0FMUnpUYUZxMTZGWnVFNWtPbWtEWWd2azBpb3RlbFg0dStOc0k2RFpBUUxWWWxjTkh5c2puMm45dmVQd2YzMkdxZmEwQUlKQ3FaVkxUTVJnZEIwNHQ4OS8xTy93MWNEbnlpbEZVPQ=='
    }
  })

const otpApi = {
  getSmsNo: request => {
    const { body, config } = request
    return instance().post(`/contact-sms-no`, body, {
      ...config
    })
  },
  postSendOtp: request => {
    const { body, config } = request
    return instance().post(`/otp-sending`, body, {
      ...config
    })
  },
  postRegister: request => {
    const { body, config } = request
    return instance().post(`/v2/register`, body, {
      ...config
    })
  }
}
export default otpApi
